const LIGHT_LUMA_THRESHOLD = 0.62;

const hexToRgb = (value) => {
  const hex = value.replace('#', '').trim();
  if (hex.length === 3) {
    return {
      r: parseInt(hex[0] + hex[0], 16),
      g: parseInt(hex[1] + hex[1], 16),
      b: parseInt(hex[2] + hex[2], 16),
    };
  }
  if (hex.length >= 6) {
    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16),
    };
  }
  return null;
};

const rgbStringToRgb = (value) => {
  const match = value.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (!match) return null;
  return { r: Number(match[1]), g: Number(match[2]), b: Number(match[3]) };
};

export const getReadableTextColor = (background) => {
  if (!background || background === 'gray') return '#FFFFFF';

  const rgb = background.startsWith('#')
    ? hexToRgb(background)
    : rgbStringToRgb(background);

  if (!rgb || [rgb.r, rgb.g, rgb.b].some((channel) => Number.isNaN(channel))) {
    return '#FFFFFF';
  }

  const luma = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  return luma > LIGHT_LUMA_THRESHOLD ? '#1F1F1F' : '#FFFFFF';
};
